import { DOCUMENT } from "@angular/common";
import {
  AfterViewInit,
  Component,
  Inject,
  ViewEncapsulation
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

const LOGIN_ROUTES = [
  "/login",
  "/forgot-password",
  "/set-password",
  "/reset-password"
];

@Component({
  selector: "ta-lcl-app",
  encapsulation: ViewEncapsulation.None,
  template: `
    <ta-site-nav *ngIf="showTopBar$ | async">
      <div app-nav>
        <ta-app-nav></ta-app-nav>
      </div>
    </ta-site-nav>

    <ta-lantern-app></ta-lantern-app>
  `
})
export class AppComponent implements AfterViewInit {
  showTopBar$: Observable<boolean> = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    map(
      (event: NavigationEnd) =>
        !LOGIN_ROUTES.some((route) => event.url.startsWith(route))
    )
  );

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: any
  ) {}

  ngAfterViewInit(): void {
    this.showTopBar$.subscribe((showTopBar) => {
      if (showTopBar) {
        this.document.body.style.paddingTop = "60px";
      } else {
        this.document.body.style.paddingTop = "0";
      }
    });
  }
}
